<template>
  <div class="page">
    <div class="page-header disFlex fc fvc">
      <img src="https://j.weizan.cn/youxiang/header-bg.png" class="bg-img" />
      <div class="time-area f fc fvc" v-if="seckillDiffTime && Object.keys(seckillDiffTime).length">
        距活动{{status==='no_start'?'开始':'结束'}}：
        <div class="time">{{seckillDiffTime.days}}</div>天
        <div class="time">{{seckillDiffTime.hours}}</div>时
        <div class="time">{{seckillDiffTime.minutes}}</div>分
        <div class="time">{{seckillDiffTime.seconds}}</div>秒
      </div>
    </div>
    <div class="page-body">
      <img
        src="https://j.weizan.cn/youxiang/live-close.png"
        class="close-icon"
        @click.stop.prevent="closeSignup"
      />
      <seckill-item :item="item" :source="'signup'"></seckill-item>

      <div class="info-item">
        <div class="f fc fbt" style="margin-bottom:15px;">
          <div class="info-title" style="font-weight:bold;margin-bottom:0;">填写个人信息</div>
        </div>

        <div class="info-input f fc">
          <img src="https://j.weizan.cn/youxiang/people.png" class="info-icon" />
          <van-field v-model="name" clearable placeholder="请输入姓名" />
        </div>
      </div>
      <div class="info-item">
        <div class="info-title">手机号码</div>
        <div class="info-input f fc">
          <img src="https://j.weizan.cn/youxiang/phone.png" class="info-icon" />
          <van-field
            v-model="phone"
            center
            clearable
            maxlength="11"
            type="number"
            placeholder="请输入手机号码"
          >
            <template #button>
              <div class="code-tip" @click="getCode" v-if="!codeSended">获取验证码</div>
              <div class="code-tip" v-else>{{codeTime}}s后重新获取</div>
            </template>
          </van-field>
        </div>
      </div>

      <div class="info-item" v-if="codeFlag">
        <div class="info-title">验证码</div>
        <div class="info-input f fc">
          <img src="https://j.weizan.cn/youxiang/phone.png" class="info-icon" />
          <van-field v-model="code" clearable placeholder="请输入验证码" maxlength="4" />
        </div>
      </div>
      <div class="info-item">
        <div class="info-title">所在区域</div>
        <div class="area-set">
          <div class="info-input2 f fc bb1" @click="choiceArea">
            <van-icon name="friends-o" class="info-icon" size="18"/>
            <van-field v-model="areaName" center maxlength="11" placeholder="请选择区域"  right-icon="arrow" readonly>
            </van-field>
          </div>
          <div class="info-input2 f fc">
            <van-icon name="wap-home-o" class="info-icon" size="18"/>
            <van-field v-model="areaNameDeatil" center maxlength="20" placeholder="请输入详细地址">
              <template #extra>
                <span style="color:#b0b0b0">{{areaNameDeatil.length}}/20</span>
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div class="info-item">
        <van-field
          v-model="remark"
          rows="1"
          autosize
          maxlength="50"
          type="textarea"
          placeholder="您希望解决的问题和需求是？（选填）"
          class="input-area"
        />
      </div>

      <div class="op-btn" @click="submit">立即提交</div>
      <van-popup
        v-model="popupAreaShow"
        round
        position="bottom"
        :style="{ height: '308px' }"
        get-container="body"
      >
        <van-area
          :area-list="areaList"
          :value="areaCode"
          @confirm="confirmArea"
          @cancel="popupAreaShow = false"
        >
        </van-area>
      </van-popup>
    </div>
  </div>
</template>

<script>
import SeckillItem from "./seckill-item";
import { getCountDownObjByStr, isChinese } from "./../utils/tools";
import { areaList } from "./../utils/area.js";
export default {
  components: {
    SeckillItem,
  },
  props: {
    item: {
      type: Object,
      default: {},
    },
    status: {
      type: String,
      default: "",
    },
    startTime: {
      type: String,
      default: "",
    },
    endTime: {
      type: String,
      default: "",
    },
    productNum: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      name: "",
      phone: "",
      code: "",
      remark: "",
      codeInterval: null,
      codeSended: localStorage.getItem("codeSended") === "true" || false,
      codeTime: Number(localStorage.getItem("codeTime")),
      codeSendedTime:
        localStorage.getItem("codeSendedTime") || new Date().getTime(),
      seckillTimeInterval: null,
      timeInterval: null,
      seckillDiffTime: {},
      popupAreaShow: false, //省市区选择
      areaList: areaList, // 省市区数据列表
      areaCode: "", // 记录选中省市区code值(回显数据)
      areaName: "", // 记录选中省市区name值(回显数据)
      areaNameDeatil: "", // 详细地址
    };
  },
  created() {
    this.areaNameDeatil = "";
    this.areaName = "";
    var location = JSON.parse(localStorage.getItem("location")) || null;
    console.log(location);
    console.log(location && location.data);
    if(location){ 
      var data = location.data;
      var areaName = "";
      if(data.province){
        areaName = areaName + data.province;
      }
      if(data.city){
        areaName = areaName + "-" + data.city;
      }
      if(data.district){
        areaName = areaName + "-" + data.district;
      }
      this.areaName = areaName;
    }
    if (this.codeSended) {
      this.calcCodeTime();
    }
    this.calcSeckillTime();
  },
  destroyed() {
    clearInterval(this.seckillTimeInterval);
    clearInterval(this.timeInterval);
  },
  computed: {
    codeFlag: function () {
      return this.phone.length === 11;
    },
  },
  methods: {
    submit() {
      if (!isChinese(this.name)) {
        this.$toast("姓名仅可输入中文");
        return false;
      }
      if (!this.code) {
        this.$toast("请输入验证码");
        return false;
      }
      if (!this.areaName) {
        this.$toast("请选择所在区域");
        return false;
      }
      if (!this.areaNameDeatil || (this.areaNameDeatil&&this.areaNameDeatil.length<5)) {
        this.$toast("请完整填写地址，不少于5个字");
        return false;
      }
      this.$http
        .post("/v1/home/enroll", {
          activityId: localStorage.getItem("act_id"),
          channel: "enrollment",
          code: this.code,
          name: this.name,
          phone: this.phone,
          suggest: this.remark,
          area: this.areaName,
          addr: this.areaNameDeatil,
        })
        .then((res) => {
          if (res.code === 0) {
            this.$emit("signupSuccess", this.callSrouce);
            // this.confirmNow();
          }
        });
    },
    confirmNow() {
      if (this.productNum === 0) {
        return this.buyNow();
      }
      this.$dialog({
        showCancelButton: true,
        messageAlign: "left",
        message: `• 每个用户仅限购买${this.productNum}款秒杀商品，您确定要秒杀这件商品吗？\n\n• 您即将参与秒杀商品抢购，秒杀商品为限量产品，秒完即止，请随时关注页面剩余数量`,
      }).then(() => {
        this.buyNow();
      });
    },
    buyNow() {
      this.$txLogs({
        bpm: "3.seckill_enrollment_submit",
      });
      // 检查购买
      this.$http
        .post("/v1/seckill/task/pre_start", {
          productId: this.item.id,
        })
        .then((res) => {
          if (res.code === 0) {
            // this.$router.push({
            //   path: "/seckillDetailNew",
            //   query: { id: this.item.id, self: true,act_id: localStorage.getItem("act_id"), },
            // });
          }
        });
    },
    calcSeckillTime() {
      let time = "";
      if (this.status === "no_start") {
        time = this.startTime;
      } else {
        time = this.endTime;
      }
      this.seckillTimeInterval = setInterval(() => {
        this.seckillDiffTime = getCountDownObjByStr(time);
        if (!this.seckillDiffTime) {
          clearInterval(this.seckillTimeInterval);
        }
      }, 1000);
    },

    getCode() {
      if (!this.phone) {
        return this.$toast(`请输入手机号码后再发送！`);
      }
      if (!/^(?:(?:\+|00)86)?1\d{10}$/.test(this.phone)) {
        return this.$toast(`请输入正确的手机号码！`);
      }
      if (this.codeSended) {
        return this.$toast(`请${this.codeTime}后再发送！`);
      }
      this.$http
        .post("/v1/home/send_code", {
          phone: this.phone,
          use: "enroll",
        })
        .then((res) => {
          if (res.code === 0) {
            this.$toast("发送成功");
            this.codeTime = 60;

            this.codeSendedTime = new Date().getTime();
            localStorage.setItem("codeSendedTime", new Date().getTime());
            localStorage.setItem("codeSended", true);
            this.calcCodeTime();
          }
        });
    },
    calcCodeTime() {
      this.codeSended = true;
      this.timeInterval = setInterval(() => {
        this.codeTime = parseInt(
          (new Date(Number(this.codeSendedTime)).getTime() +
            60000 -
            new Date().getTime()) /
            1000
        );

        if (this.codeTime > 0) {
          localStorage.setItem("codeTime", --this.codeTime);
        } else {
          localStorage.setItem("codeSended", false);
          localStorage.removeItem("codeSendedTime");
          this.codeSended = false;
          clearInterval(this.timeInterval);
        }
      }, 1000);
    },
    closeSignup() {
      this.$emit("closeSignup");
    },
    choiceArea(){
      // Area 省市区
      this.popupAreaShow = true;
      this.areaCode = "110000";
    },
    // Area 省市区 点击右上方完成按钮
    confirmArea(area) {
      this.areaName = "";
      var areaName = "";
      console.log(area);
      if(area&&area.length>0){
        if(area[0]){
          areaName = areaName + area[0].name;
        }
        if(area[1]){
          areaName = areaName + "-" +  area[1].name;
        }
        if(area[2]){
          areaName = areaName + "-" +  area[2].name;
        }
      }
      this.areaName = areaName;
      this.popupAreaShow = false;
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background: #fff;
  .page-header {
    background: #003078;
    position: relative;
    height: 58px;
    .bg-img {
      position: absolute;
      right: 0;
      top: 0;
      width: 151px;
      height: 190px;
    }
    .time-area {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 24px;
    }
    .time {
      width: 19px;
      height: 18px;
      background: rgba(0, 27, 68, 1);
      border-radius: 2px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 18px;
      text-align: center;
      margin: 0 5px;
    }
  }
  .page-body {
    height: calc(100vh - 58px);
    background: rgba(255, 255, 255, 1);
    border-radius: 15px 15px 0px 0px;
    padding: 12px 16px 0;
    position: relative;
    .info-item {
      margin-bottom: 15px;
      .input-area {
        -webkit-user-select: text;
        background: #f5f6f7;
        border-radius: 5px;
      }
      .info-title {
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(53, 53, 53, 1);
        margin-bottom: 15px;
      }
      .area-set{
        border: 1px solid #b0b0b0;
        border-radius: 5px;
        .info-input2 {
          overflow: hidden;
          margin: 0 13px;

          height: 45px;
        }
        .bb1{
          border-bottom: 1px solid #dadada;
        }
      }
      .info-input {
        overflow: hidden;
        padding: 0 13px;

        height: 45px;
        border: 1px solid #b0b0b0;
        border-radius: 5px;
      }
      .info-icon {
        width: 18px;
        height: 18px;
      }
      .close-icon {
        width: 18px;
        height: 18px;
      }
      .code-tip {
        margin-left: auto;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(0, 48, 120, 1);
      }
      input {
        border: none;
      }
      textarea {
        width: 100%;
        height: 66px;
        background: rgba(245, 246, 247, 1);
        opacity: 0.5;
        border-radius: 5px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        padding: 15px;
      }
    }
    .op-btn {
      width: 315px;
      height: 44px;
      background: rgba(0, 48, 120, 1);
      border-radius: 22px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 44px;
      margin: 15px auto;
    }
  }
  .close-icon {
    width: 18px;
    height: 18px;
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 100;
  }
}
</style>